import { WImage, WLink } from '@components/atoms'
import { EffettiType } from '@utils/types'
import styles from './EffettoCard.module.sass'

interface Props {
  className?: string
  item: EffettiType
}

const EffettoCard = (props: Props) => {
  const { className = '', item } = props

  return (
    <WLink href={item.url} className={`${styles.root} ${className}`}>
      <div className={styles.imageBox}>
        <WImage
          src={item.mainImage}
          alt={item?.imageAlt}
          maxWidth={1080}
          maxHeight={98}
          objectFit="cover"
        />
      </div>
      <p className={styles.title}>{item.title}</p>
    </WLink>
  )
}

export default EffettoCard
